import * as React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import DownloadAppSection from "../components/DownloadAppSection";
import Footer from "../components/Footer";
import AboutPage from "../pages/About";
import { Outlet } from "react-router-dom";

function WebsiteContent() {
  return (
    <div className="flex flex-col min-h-screen ">
      <Header className="sticky top-0 z-50" />
      {/* <HeroSection />
      <DownloadAppSection /> */}
      {/* <AboutPage /> */}

      <Outlet />

      <Footer />
    </div>
  );
}

export default function WebsiteLayout() {
  return <WebsiteContent />;
}
